import I10n from '../../features/i10n';
import { possibleLengthUnitFormat } from '../../constants';

export let lengthUnitFormat = possibleLengthUnitFormat.mm;

export const setLengthUnitFormat = (format) => {
  if (Object.values(possibleLengthUnitFormat).indexOf !== -1) {
    lengthUnitFormat = format;
  }
}

export const formatLengthUnit = (value) => {
  if (lengthUnitFormat === possibleLengthUnitFormat.inch && value !== '-') {
    return `${(value / 25.4).toFixed(2)} ${I10n.get('unit.inch', 'data')}`;
  }

  return `${value} ${I10n.get('unit.mm', 'data')}`;
}
